import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { Box } from "@miro-site/core";
import Header from "./Header";
import Content from "./Content";
var Item = function(_param) {
    var children = _param.children, header = _param.header, onExpand = _param.onExpand, onCollapse = _param.onCollapse, props = _object_without_properties(_param, [
        "children",
        "header",
        "onExpand",
        "onCollapse"
    ]);
    var ref = useState(false), isExpanded = ref[0], setIsExpanded = ref[1];
    var onClick = function() {
        if (!isExpanded && onExpand) {
            onExpand();
        }
        if (isExpanded && onCollapse) {
            onCollapse();
        }
        setIsExpanded(!isExpanded);
    };
    return /*#__PURE__*/ _jsxs(Box, _object_spread_props(_object_spread({
        as: "section"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(Header, {
                onClick: onClick,
                isExpanded: isExpanded,
                children: header
            }),
            /*#__PURE__*/ _jsx(Content, {
                isExpanded: isExpanded,
                children: children
            })
        ]
    }));
};
export default Item;
